import React, { Component } from 'react';
import { FormattedMessage  } from 'react-intl';
import { Link } from "react-router-dom";
import axios from 'axios'
import PropTypes from 'prop-types';
import { CSVLink } from "react-csv"
import SearchTable from './SearchTable'
import LoadingControl from './Loading';
import DownloadButton from '../controls/DownloadButton';
import { getCurrencySymbol, isColorToString, isDuplexToString, compareStrings } from '../utils/utils';
import { USERS_PATH, PRINTERS_PATH, COMPUTERS_PATH } from '../utils/constants';

class DocumentsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            isLoaded: false,
            data: null,
            csvData: []
          };

        this.layout = {
            bordered : true,
            showSizeChanger : true, 
            pagination : {pageSize: props.pageSize ? props.pageSize : 10, showSizeChanger: false},
            size: "small",
            rowKey : record => record.id,
        };

        this.wasUpdated = false;

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        this.columns = [
            {
              title: <FormattedMessage id="DeviceMetersTable.name"/>,
              dataIndex: 'name',
              search: true,
              sorter: {
                compare: (a, b) => compareStrings(a.name, b.name),
              },
              render: (_, record) => {
                if (record.jobDataType === 1 && record.jobDataSize > 0)
                {
                    const url = axios.defaults.baseURL + "/job_data/" + record.id;
                    return(
                    <div>
                        <a href={url}>{record.name}</a>
                    </div>
                    );
                }
                else
                {
                    return(
                        <div>{record.name}</div>
                        );    
                }
              }
            },
            {
                title: <FormattedMessage id="Printer"/>,
                dataIndex: 'prnName',
                search: true,
                sorter: {
                  compare: (a, b) => compareStrings(a.prnName, b.prnName)
                },
                render: (_, record) => {
                    const url = PRINTERS_PATH + "/" + record.printerId + (this.props.parent_id_param !== undefined ? this.props.parent_id_param : "");
                    return(
                    <div>
                        <Link to={url}>{record.prnName}</Link>
                    </div>
                    );
                  }   
            },
            {
                title: <FormattedMessage id="User"/>,
                dataIndex: 'userName',
                search: true,
                sorter: {
                  compare: (a, b) => compareStrings(a.userName, b.userName)
                },
                render: (_, record) => {
                    const url = USERS_PATH + "/" + record.userId + (this.props.parent_id_param !== undefined ? this.props.parent_id_param : "");
                    return(
                    <div>
                        <Link to={url}>{record.userName}</Link>
                    </div>
                    );
                  }   
            },
            {
                title: <FormattedMessage id="Computer"/>,
                dataIndex: 'compName',
                search: true,
                sorter: {
                  compare: (a, b) => compareStrings(a.compName, b.compName),
                },
                render: (_, record) => {
                    const url = COMPUTERS_PATH + "/" + record.computerId + (this.props.parent_id_param !== undefined ? this.props.parent_id_param : "");
                    return(
                    <div>
                        <Link to={url}>{record.compName}</Link>
                    </div>
                    );
                  }   
            },
            {
                title: <FormattedMessage id="Data"/>,
                dataIndex: 'submitDate',
                width:150,               
                sorter: {
                  compare: (a, b) => 
                  {
                      const time_a = Date.parse(a.submitDate);
                      const time_b = Date.parse(b.submitDate);
                      return time_a - time_b;
                  }
                },
                search: true,
                render: (_, record) =>
                <div>
                    {record.submitDate !== undefined && new Date(record.submitDate).toLocaleString(navigator.language || navigator.userLanguage)}
                </div>
            },
            {
                title: <FormattedMessage id="Pages"/>,
                dataIndex: 'pages',             
                sorter: {
                  compare: (a, b) => 
                  {
                      return a.pages - b.pages;
                  }
                },
                search: true,
            },
            {
                title: <FormattedMessage id="PaperName"/>,
                dataIndex: 'paperName',             
                sorter: {
                    compare: (a, b) => compareStrings(a.paperName, b.paperName)
                },
                search: true,
            },
            {
                title: <FormattedMessage id="Cost"/>,
                dataIndex: 'cost',
                sorter: {
                    compare: (a, b) => a.cost - b.cost,
                },
                search: true,
                render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
            },
            {
                title: <FormattedMessage id="Color"/>,
                dataIndex: 'color',        
                sorter: {
                    compare: (a, b) => a.color - b.color,
                },
                filters: [
                    { text: <FormattedMessage id="Yes"/>, value: 1 },
                    { text: <FormattedMessage id="No"/>, value: 0 },
                  ],
                filterMultiple: false,
                onFilter: (value, record) => {
                    if (value === 1) {
                        return record.color === 2;
                    }
                    else if (value === 0) {
                        return record.color === 1;
                    }
                    else {
                        return true;
                    }
                },
                render: (_, record) =>
                <div>
                    <FormattedMessage id={isColorToString(record.color)}/>
                </div>
            },
            {
                title: <FormattedMessage id="Duplex"/>,
                dataIndex: 'duplex',
                sorter: {
                    compare: (a, b) => a.duplex - b.duplex,
                },
                filters: [
                    { text: <FormattedMessage id="Yes"/>, value: 1 },
                    { text: <FormattedMessage id="No"/>, value: 0 },
                  ],
                filterMultiple: false,
                onFilter: (value, record) => {
                    if (value === 1) {
                        return record.duplex > 1;
                    }
                    else if (value === 0) {
                        return record.duplex === 1;
                    }
                    else {
                        return true;
                    }
                },
                render: (_, record) =>
                <div>
                    <FormattedMessage id={isDuplexToString(record.duplex)}/>
                </div>
            },
        ];   
      }

      async getData(url) {
      
        const res = await axios(url);
        return res.data;
        }

    update(url) {
        this.setState({isLoaded: false});
    
        this.getData(url)
        .then(res => {
            this.setState({ error: null, isLoaded: true, data: res });
        })
        .catch(err => {
            console.log(err);
            this.setState( {error: err, isLoaded: false, server: null });
        });
        }  
        
    componentDidMount() {
        if (this.props.api_url === undefined)
        {
            this.setState( {error: {message : "Bad API request"}});
        }
        else
        {
            this.update(this.props.api_url);
        }
    }

    componentDidUpdate(prevProps) {        
        if (this.wasUpdated !== true || this.props.api_url !== prevProps.api_url)
        {
            this.update(this.props.api_url);
            this.wasUpdated = true;
        }
      }
     
      componentWillUnmount() {
        this.wasUpdated = false;
      }  

    onSelectChange(selectedRowKeys) {
        if (this.props.onSelectChange !== undefined)
        {
            this.props.onSelectChange(selectedRowKeys);
        }
    }

    onCSVExportClick()
    {
      this.setState({ csvData: this.state.data }, () => {
        this.csvLink.link.click()}
      );

    }

     render() {
        if(this.state.error != null)
        {
            return (
                <div>
                    <h3>{this.state.error.message}</h3>
                </div>
            );
        }
        else if (!this.state.isLoaded)
        {
            return (
                <div className = "style-center"><LoadingControl/></div>
            );
        }
        else if (!this.props.csvExport)
        {    
        return (
            <div className = "report-table">
                <SearchTable
                    layout = {this.layout}
                    type = {undefined}
                    columns={this.columns} 
                    dataSource={this.state.data} 
                />
            </div>
        );
        }
        else
        {
            return (
            <div className = "history-pane-header">
                <div className = "range-picker">&#8202;</div>
                <CSVLink 
                data={this.state.csvData}
                separator=";"
                ref={(r) => this.csvLink = r}
                filename="documents.csv"
                className="hidden"
                target="_blank">                
                </CSVLink>
                <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/> 
                <div className = "report-table">
                    <SearchTable
                        layout = {this.layout}
                        type = {undefined}
                        columns={this.columns} 
                        dataSource={this.state.data} 
                    />
                </div>
            </div>
            );
        }
    }
} 
       
    DocumentsTable.propTypes = {
    api_url: PropTypes.string.isRequired,
    };

export default DocumentsTable;
